import React, { Fragment } from 'react'
import { Checkbox } from 'components/forms'
import weekDaysGetter from './fragments/weekDaysGetter'
import dateTimeFormatter from 'helpers/dateTimeFormatter'
import { DATE_FORMAT } from 'config/consts'
import { numberColumn } from 'components/DataTable'

export const productList = t => ([
	{
		Header: <span className='sort-icons'>{t('product_section.fields.number')}</span>,
		accessor: 'code',
		width: 90,
		Cell: ({ original, value }) => <span style={{ color: original?.isActive ? 'unset' : 'lightgray' }}>{value}</span>
	}, {
		Header: t('product_section.fields.name'),
		accessor: 'name',
		Cell: ({ original, value }) => <span style={{ color: original?.isActive ? 'unset' : 'lightgray' }}>{value}</span>
	}
])

export const hardwareDx = t => [
	{
		caption: t('product_section.strings.ean_code'),
		dataField: 'EANCode',
		width: 300,
		cellRender: ({ data: { isActive, EANCode } }) => {
			return (
				<div className={!isActive ? 'disabled' : ''}>{Array.isArray(EANCode) ?
					EANCode.map((item, i, arr) => item).join(', \n')
					: EANCode}
				</div>
			)
		}
	}, {
		caption: t('product_section.fields.number'),
		dataField: 'code',
		cellRender: ({ data: { isActive, code } }) => {
			return <div className={!isActive ? 'disabled' : ''}>{code}</div>
		}
	}, {
		caption: t('product_section.fields.name'),
		dataField: 'name',
		cellRender: ({ data: { isActive, name } }) => {
			return <div className={!isActive ? 'disabled' : ''}>{name}</div>
		}
	}, {
		caption: t('product_section.strings.info'),
		dataField: 'isActive',
		cellRender: ({ data: { isActive } }) => {
			return (
				<div className={!isActive ? 'disabled' : ''}>
					{isActive ? t('product_section.strings.product_active') : t('product_section.strings.product_not_active')}
				</div>
			)
		}
	}
]

export const hardware = [
	{
		Header: 'EAN Code',
		accessor: 'EANCode',
		Cell: ({ original = {} }) => Array.isArray(original.EANCode) ?
			original.EANCode.map((item, i, arr) => <Fragment key={i}>{item}{i !== (arr.length - 1) && <br />}</Fragment>)
			: original.EANCode
	}, {
		Header: 'Nummer',
		accessor: 'code'
	}, {
		Header: 'Bezeichnung',
		accessor: 'name'
	}, {
		Header: 'Info',
		accessor: 'isActive',
		Cell: ({ original }) => original.isActive ? 'Artikel ist aktiviert' : 'Artikel ist nicht aktivier'
	}
]

export const lists = [
	{
		accessor: 'id',
		show: false
	}, {
		Header: 'Name Liste',
		accessor: 'name'
	}
]

export const price = t => [
	{
		Header: t('product_section.strings.type'),
		accessor: 'typeName'
	}, {
		Header: t('common.fields.from_date'),
		accessor: 'fromDate',
		Cell: ({ value }) => dateTimeFormatter(value, DATE_FORMAT)
	}, {
		Header: t('common.fields.to_date'),
		accessor: 'toDate',
		Cell: ({ value }) => dateTimeFormatter(value, DATE_FORMAT)
	}, {
		Header: t('product_section.fields.name'),
		accessor: 'name'
	}
]

export const restaurant = (t, variantsAmount) => {
	const outCols = [
		{
			accessor: 'id',
			show: false
		},
		{
			Header: t('product_section.strings.additive'),
			accessor: 'isActive'
		}, {
			Header: t('product_section.fields.name'),
			accessor: 'name'
		}
	]
	for(let i = 0; i < variantsAmount; i++) {
		outCols.push({
			Header: `${t('product_section.strings.variant')} ${i + 1}`,
			accessor: 'variants',
			Cell: ({ original: { variants } }) => Array.isArray(variants) && variants[i] ? variants[i] : '-'
		})
	}
	return outCols
}

export const selection = t => [
	{
		Header: t('product_section.fields.number'),
		accessor: 'code',
		width: 90
	}, {
		Header: t('category_section.caption'),
		accessor: 'categoryName'
	}, {
		Header: t('product_section.strings.min_quantity'),
		accessor: 'minQuantity',
		style: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('product_section.strings.max_quantity'),
		accessor: 'maxQuantity',
		style: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('product_section.strings.fixed_quantity'),
		accessor: 'fixProduct',
		Cell: ({ value }) => Array.isArray(value) ? value.length ? <div>{value.map((val, i) => <div className='cell-row' key={i}>{val || '-'}</div>)}</div> : '-' : value || '-'
	}, {
		Header: t('common.fields.quantity'),
		accessor: 'amount',
		Cell: ({ value }) => Array.isArray(value) ? value.length ? <div>{value.map((val, i) => <div className='cell-row' key={i}>{val || '-'}</div>)}</div> : '-' : value || '-'
	}, {
		Header: t('product_section.strings.price'),
		accessor: 'price',
		Cell: ({ value }) => Array.isArray(value) ? value.length ? <div>{value.map((val, i) => <div className='cell-row' key={i}>{val || '-'}</div>)}</div> : '-' : value || '-'
	}
]

export const selectionProduct = t => [
	{
		Header: t('common.fields.code'),
		accessor: 'code'
	}, {
		Header: t('product_section.caption'),
		accessor: 'name'
	}, {
		Header: t('common.fields.quantity'),
		accessor: 'amount',
		...numberColumn({ toFixed: 0 })
	}, {
		Header: t('product_section.strings.price'),
		accessor: 'price',
		...numberColumn()
	}
]

export const ingredients_allergens = [
	{
		Header: 'Nummer',
		accessor: 'code'
	}, {
		Header: 'Enthält',
		accessor: 'contains',
		Cell: ({ value }) => <Checkbox noForm defaultChecked={value} />
	}, {
		Header: 'Bezeichnung',
		accessor: 'name'
	}
]

export const ingredients_nutrients = t => [
	{
		Header: t('product_section.fields.number'),
		accessor: 'code'
	}, {
		Header: t('product_section.fields.weight'),
		accessor: 'amount',
		Cell: ({ original, value }) => (original.units === '' || original.units === null) ? '' : (value === null ? '' : Number(value).toFixed(2)),
		style: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('product_section.fields.description'),
		accessor: 'name'
	}, {
		Header: t('product_section.fields.unit'),
		accessor: 'units',
		width: 70
	}, {
		accessor: 'group',
		show: false
	}, {
		accessor: 'keyword',
		show: false
	}
]

export const availability_intervals = t => [
	{
		Header: t('common.strings.from'),
		accessor: 'dateInterval',
		Cell: ({ value = {} }) => dateTimeFormatter(value.from, DATE_FORMAT)
	}, {
		Header: t('common.strings.to'),
		accessor: 'dateInterval',
		Cell: ({ value = {} }) => dateTimeFormatter(value.to, DATE_FORMAT)
	}, {
		Header: t('product_section.strings.repeat'),
		accessor: 'replay',
		Cell: ({ value }) => (
			<Checkbox checked={value} noForm readOnly />
		)
	}, {
		Header: t('common.dates.days'),
		accessor: 'weekDays',
		Cell: ({ value }) => weekDaysGetter(value)
	}, {
		Header: t('product_section.strings.comment'),
		accessor: 'description'
	}, {
		accessor: 'cashRegisterId',
		show: false
	}
]
